import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalizationService } from '@services/localization.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'deposit-frame-dialog',
  templateUrl: '../sharedTemplates/deposit-frame-dialog.html',
})
export class DepositFrameDialog {
  iframesrc;
  constructor(
    public dialogRef: MatDialogRef<DepositFrameDialog>,
    public _LocalizationService: LocalizationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private domSanitizer: DomSanitizer,
    private _UiHelper: UiHelper
  ) {
    this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(data.depositurl);
  }

  paymentpageLoaded() {
    this._UiHelper.setLoadingDialog(false);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
